import { alpha } from "@mui/material";
import { Measure } from "types/types";

interface Props {
  measure: Measure;
}

export function TreeTrunkSvg(props: Props) {
  const { measure } = props;
  return (
    <>
      <svg
        className="hidden-svg"
        width="0"
        height="0"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <radialGradient id={measure.name}>
            <stop offset="0%" stopColor="#a67b52" />
            <stop offset="10%" stopColor="#a67b52" />
            <stop offset="10%" stopColor={alpha(measure.color, 0.6)} />
          </radialGradient>
        </defs>
      </svg>
      <svg
        className="hidden-svg"
        width="0"
        height="0"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <radialGradient id={`${measure.name}-trunk-highlight`}>
            <stop offset="0%" stopColor="#a67b52" />
            <stop offset="10%" stopColor="#a67b52" />
            <stop offset="10%" stop-color={alpha(measure.color, 0.6)} />
            <stop offset="85%" stop-color={alpha(measure.color, 0.6)} />
            <stop offset="85%" stop-color="#e8341c" />
          </radialGradient>
        </defs>
      </svg>
      <svg
        className="hidden-svg"
        width="0"
        height="0"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <radialGradient id={`${measure.name}-highlight`}>
            <stop offset="90%" stopColor={alpha(measure.color, 0.6)} />
            <stop offset="90%" stopColor="red" />
          </radialGradient>
        </defs>
      </svg>
    </>
  );
}

//projecttool
//waterpaspoort
//walkability - denis design - en kleine ticketjes
//stortplaatsen - klein ticketj
//atmosys
//basf

//ruimtemonitor
